/* Copyright 2013 - 2022 Waiterio LLC */
const DEVELOPMENT = require('./DEVELOPMENT')
const ENVIRONMENT = require('./ENVIRONMENT')

module.exports = ENVIRONMENT === DEVELOPMENT
